import axiosInstance from '../api';

export interface ClosingCostsData {
  costs: number;
  proceeds: number;
  attorneyFee: number;
  termiteFee: number;
  brokerFee: number;
  titleFee: number;
  taxFee: number;
  mortgageBalance: number;
  miscFee: number;
  bac: number;
  concessions: number;
}

const closingCostsService = {
  find: async (listingId: string, offerId?: string, price?: number, token?: string): Promise<ClosingCostsData> => {
    const res = await axiosInstance.get<ClosingCostsData>('/closing-costs', {
      params: {
        listingId,
        offerId,
        price,
        ...(token && { token }),
      },
    });
    return res.data;
  },
};

export default closingCostsService;
